import { createContext, useContext } from 'react';

/** Ids and validity state that `Field` hands down to whatever control it wraps. */
export interface FieldControlContext {
  readonly controlId: string;
  /** Space-separated ids of the hint and error nodes, or `undefined` when there are none. */
  readonly describedBy: string | undefined;
  readonly invalid: boolean;
  readonly required: boolean;
  readonly disabled: boolean;
}

export const FieldContext = createContext<FieldControlContext | null>(null);

/** Returns the wiring provided by an enclosing `Field`, or `null` for a standalone control. */
export function useFieldControl(): FieldControlContext | null {
  return useContext(FieldContext);
}
